import SelectToggleController from './select_toggle_controller';

export default class extends SelectToggleController {
  connect() {
    this.toggle();
  }
}
